import dynamic from 'next/dynamic';
import { useBlog } from '../../lib/hooks.context';
import { BenefitTeaser } from '../../types';

const ExtendableBenefitsList = dynamic(() => import('./ExtendableList'));
const PlainList = dynamic(() => import('./PlainList'));

const BenefitsList = ({ benefits }: { benefits: BenefitTeaser[] }) => {
  const blog = useBlog(false);

  if (!blog) {
    return <ExtendableBenefitsList benefits={benefits} />;
  }

  return <PlainList benefits={benefits} />;
};

export default BenefitsList;
